import {Routes} from "../../../config/routes";
import {Link} from "react-router-dom";
import * as React from "react";
import Utils from "../../../Utils";

export default class NavigationManager {
    navigationComponent = null;

    init(navigationComponent) {
        this.navigationComponent = navigationComponent;
    }

    get homeChildren() {
        return {
            [Routes.GLOBAL_SEARCH]: <li className={this.navigationComponent.activeRoute("globalsearch")}>
                <Link to={`${process.env.ENV_PREFIX}${Routes.GLOBAL_SEARCH}`}><i
                    className="fas fa-table fa-lg"/> <span
                    className="nav-label">Global Search</span></Link>
            </li>,
            [Routes.MANAGE_DATA]: <li className={this.navigationComponent.activeRoute("managedata")}>
                <Link
                    to={{
                        pathname: `${process.env.ENV_PREFIX}${Routes.MANAGE_DATA}`,
                        state: {from: this.navigationComponent.props.history.location.pathname}
                    }}><i
                    className="fas fa-table fa-lg"/> <span
                    className="nav-label">Manage Data</span></Link>
            </li>
        }
    }

    get accessControlChildren() {
        return {
            [Routes.FUNCTIONALITIES]: <li className={this.navigationComponent.activeRoute("functionalities")}>
                <Link to={`${process.env.ENV_PREFIX}${Routes.FUNCTIONALITIES}`} style={{paddingLeft: 50}}>
                    <i className="fas fa-cog"/>
                    <span className="nav-label">Functionalities</span>
                </Link>
            </li>,
            [Routes.ROLES]: <li className={this.navigationComponent.activeRoute("roles")}>
                <Link to={`${process.env.ENV_PREFIX}${Routes.ROLES}`} style={{paddingLeft: 50}}>
                    <i className="fas fa-user-cog"/>
                    <span className="nav-label">Roles</span>
                </Link>
            </li>,
            [Routes.USERS]: <li className={this.navigationComponent.activeRoute("users")}>
                <Link to={`${process.env.ENV_PREFIX}${Routes.USERS}`} style={{paddingLeft: 50}}>
                    <i className="fas fa-users-cog"/>
                    <span className="nav-label">Users</span>
                </Link>
            </li>,
            [Routes.GROUPS]: <li className={this.navigationComponent.activeRoute("groups")}>
                <Link to={`${process.env.ENV_PREFIX}${Routes.GROUPS}`} style={{paddingLeft: 50}}>
                    <i className="fas fa-users"/>
                    <span className="nav-label">Groups</span>
                </Link>
            </li>
        }
    }
    get statusAndLogsChildren() {
        return {
            [Routes.AUDIT_LOG]: <li className={this.navigationComponent.activeRoute("auditlog")}>
                <Link to={`${process.env.ENV_PREFIX}${Routes.AUDIT_LOG}`} style={{paddingLeft: 50}}>
                    <i className="fas fa-cog"/>
                    <span className="nav-label">Audit Log</span>
                </Link>
            </li>,
            [Routes.STATUS]: <li className={this.navigationComponent.activeRoute("status")}>
                <Link to={`${process.env.ENV_PREFIX}${Routes.STATUS}`} style={{paddingLeft: 50}}>
                    <i className="fas fa-user-cog"/>
                    <span className="nav-label">Status</span>
                </Link>
            </li>
        }
    }

    get configurationChildren() {
        return {
            [Routes.BUSINESS_OBJECTS]: <li className={this.navigationComponent.activeRoute("businessobjects")}>
                <Link to={`${process.env.ENV_PREFIX}${Routes.BUSINESS_OBJECTS}`}>
                    <i className="fas fa-project-diagram fa-sm"/>
                    <span className="nav-label">Business Objects</span>
                </Link>
            </li>,
            [Routes.DATA_VIEW_CONFIG]: <li className={this.navigationComponent.activeRoute("dataviewconfiguration")}>
                <Link to={`${process.env.ENV_PREFIX}${Routes.DATA_VIEW_CONFIG}`}>
                    <i className="fas fa-table fa-sm"/>
                    <span className="nav-label">Data Views</span>
                </Link>
            </li>,
            [Routes.TAG_MANAGEMENT]: <li className={this.navigationComponent.activeRoute("tagmanagement")}>
                <Link to={`${process.env.ENV_PREFIX}${Routes.TAG_MANAGEMENT}`}>
                    <i className="fas fa-tags fa-sm"/>
                    <span className="nav-label">Tag Management</span>
                </Link>
            </li>,
        }
    }

    get ruleEngineChildren() {
        return {
            [Routes.RULE_ENGINE_RULES]: <li
                className={this.navigationComponent.activeRoute(`managedata?boc=${Utils.SysRuleEngineRules}`)}>
                <Link
                    to={`${process.env.ENV_PREFIX}${Routes.MANAGE_DATA}?boc=${Utils.SysRuleEngineRules}`}
                    style={{paddingLeft: 50}}><i
                    className="fas fa-list-ol fa-sm"/> <span
                    className="nav-label">Rules</span></Link>
            </li>,
            [Routes.RULE_ENGINE_ACTIONS]: <li
                className={this.navigationComponent.activeRoute(`managedata?boc=${Utils.SysRuleEngineActions}`)}>
                <Link
                    to={`${process.env.ENV_PREFIX}${Routes.MANAGE_DATA}?boc=${Utils.SysRuleEngineActions}`}
                    style={{paddingLeft: 50}}><i
                    className="fas fa-play"/> <span
                    className="nav-label">Actions</span></Link>
            </li>
        }
    }

    get UsersAndTenantsChildren() {
        return {
            [Routes.USER_MANAGEMENT]: <li
                className={this.navigationComponent.activeRoute(`usermanagement`)}>
                <Link
                    to={`${process.env.ENV_PREFIX}${Routes.USER_MANAGEMENT}`}
                    style={{paddingLeft: 50}}>
                    <i className="fas fa-users-cog" /> <span
                    className="nav-label">Join Requests</span></Link>
            </li>,
            [Routes.TENANT_MANAGEMENT]: <li
                className={this.navigationComponent.activeRoute(`tenantmanagement`)}>
                <Link
                    to={`${process.env.ENV_PREFIX}${Routes.TENANT_MANAGEMENT}`}
                    style={{paddingLeft: 50}}>
                    <i className="fas fa-object-group"/> <span
                    className="nav-label">Tenant Management</span></Link>
            </li>
        }
    }

    get configurationGroup() {
        return [
            Routes.BUSINESS_OBJECTS, Routes.DATA_VIEW_CONFIG,
            Routes.TAG_MANAGEMENT, Routes.AUDIT_LOG, Routes.ROLES,
            Routes.GROUPS, Routes.FUNCTIONALITIES,
            Routes.USERS, Routes.RULE_ENGINE_RULES,
            Routes.RULE_ENGINE_ACTIONS
        ]
    }

    get accessControlGroup() {
        return [
            Routes.ROLES, Routes.GROUPS, Routes.FUNCTIONALITIES, Routes.USERS
        ]
    }

    get statusAndLogsGroup() {
        return [
            Routes.AUDIT_LOG, Routes.STATUS
        ]
    }

    get ruleEngineGroup() {
        return [
            Routes.RULE_ENGINE_RULES, Routes.RULE_ENGINE_ACTIONS
        ]
    }

    get homeGroup() {
        return [
            Routes.MANAGE_DATA, Routes.GLOBAL_SEARCH,
        ]
    }

    get usersAndTenantsGroup() {
        return [
            Routes.TENANT_MANAGEMENT, Routes.USER_MANAGEMENT,
        ]
    }
}



// WEBPACK FOOTER //
// ./app/components/common/Navigation/NavigationManager.tsx